// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__Mce0G","label":"styles_label__-Zb01","value":"styles_value__YlK1l"};